import { Injectable } from '@angular/core';

import { EventPublish, GroupedFieldsViewGlobalEntityType, GroupedFieldsViewParentEntityType } from '@azavista/servicelib';
import { IField } from '@azavista/components/shared';
import { SpecialFilterFieldId } from './grouped-fields-order/enums';
import { TranslationKey } from '../enums';
import { SharedService } from '../shared.service';
import { RequiredScopesService } from '../required-scopes.service';

@Injectable({
    providedIn: 'root'
})
export class GroupedFieldsViewService {
    private eventStatuses = [
        EventPublish.PUBLISHED,
        EventPublish.OFF_LINE,
        EventPublish.NO_REGISTRATION,
        EventPublish.APPROVED,
        EventPublish.CANCELLED,
        EventPublish.DRAFT
    ];

    constructor(private sharedSvc: SharedService, private rsSvc: RequiredScopesService) {
    }

    getViewsScopes(globalEntityType?: GroupedFieldsViewGlobalEntityType, parentEntityType?: GroupedFieldsViewParentEntityType): string[] {
        let scopes: string[] = [];
        if (globalEntityType) {
            if (globalEntityType === GroupedFieldsViewGlobalEntityType.contact
                || globalEntityType === GroupedFieldsViewGlobalEntityType.organization) {
                scopes = this.rsSvc.getRequiredCRMViewsScopes();
            }
        } else if (parentEntityType) {
            if (parentEntityType === GroupedFieldsViewParentEntityType.event) {
                scopes = this.rsSvc.getRequiredEventViewsScopes();
            } else if (parentEntityType === GroupedFieldsViewParentEntityType.participant) {
                scopes = this.rsSvc.getRequiredEventParticipantViewsScopes();
            }
        }
        return scopes;
    }

    getEventSettingsPublishField(): IField {
        const eventSettingsPublishField = {
            id: SpecialFilterFieldId.eventSettingsPublish, label: this.sharedSvc.translate(TranslationKey.eventStatus),
            name: SpecialFilterFieldId.eventSettingsPublish, type: 'select',
            schema: { type: 'string', enum: this.eventStatuses }
        } as IField;
        return eventSettingsPublishField;
    }
}
